import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { Observable } from 'rxjs';
import { IrcpProjetoService } from '../services/ircp-projeto.service';


@Injectable({
  providedIn: 'root'
})
export class IrcpProjetoResolver implements Resolve<boolean> {

  constructor(private service: IrcpProjetoService) { }

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    return this.service.getById(route.params.id);
  }
}

@Injectable({
  providedIn: 'root'
})
export class IrcpProjetoCombosResolver implements Resolve<boolean> {

  constructor(private service: IrcpProjetoService) { }

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    return this.service.listCombos(route.parent.parent.params.idProjeto);
  }
}

@Injectable({
  providedIn: 'root'
})
export class AditivoIrcpResolver implements Resolve<boolean> {

  constructor(private service: IrcpProjetoService) { }

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    let aditivo_id = route.queryParams['aditivo_id'];
    return this.service.getAditivoById(aditivo_id);
  }
}

@Injectable({
  providedIn: 'root'
})
export class AditivoIrcpInitResolver implements Resolve<boolean> {

  constructor(private service: IrcpProjetoService) { }

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    return this.service.getAditivoInit(route.params.id);
  }
}

@Injectable({
  providedIn: 'root'
})
export class TiposAditivosIrcpListResolver implements Resolve<boolean> {

  constructor(private service: IrcpProjetoService) { }

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    return this.service.getTiposAditivosList();
  }
}